import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedWarningYellow48 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.97949 42.0625L23.7503 4.45837L45.5212 42.0625H1.97949ZM23.7503 36.125C24.3111 36.125 24.7811 35.9354 25.1605 35.556C25.5398 35.1767 25.7295 34.7066 25.7295 34.1459C25.7295 33.5851 25.5398 33.1151 25.1605 32.7357C24.7811 32.3564 24.3111 32.1667 23.7503 32.1667C23.1896 32.1667 22.7195 32.3564 22.3402 32.7357C21.9608 33.1151 21.7712 33.5851 21.7712 34.1459C21.7712 34.7066 21.9608 35.1767 22.3402 35.556C22.7195 35.9354 23.1896 36.125 23.7503 36.125ZM21.7712 30.1875H25.7295V20.2917H21.7712V30.1875Z",
		fill: "url(#paint0_linear_18555_4989)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_18555_4989",
		x1: 1.75038,
		y1: 42.5574,
		x2: 48.3824,
		y2: 7.46066,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#FFA51F" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#FFA51F"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFF3DF"
			})
		]
	}) })]
});
export default SvgExtendedWarningYellow48;
